import React from 'react';
import { Button, CircularProgress } from '@mui/material';
import { DeleteOutlineOutlined, FilePresentOutlined } from '@mui/icons-material';

import { primaryBlue, statusError, statusTextError } from 'utils/color-styles';

import { FileWithMeta } from './FilesUpload';

interface Props {
  fileWithMeta: FileWithMeta;
  onDelete: () => void;
  errorCountdown?: number;
}
export const File = ({ fileWithMeta, onDelete, errorCountdown }: Props) =>
  fileWithMeta.status === 'error' ? (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        borderRadius: 4,
        background: statusError,
        padding: '6px 16px',
        color: statusTextError,
        marginTop: 16,
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <div style={{ fontSize: 14, marginLeft: 8 }}>{fileWithMeta.errorMessage}</div>
      </div>

      <div style={{ display: 'flex', alignItems: 'center' }}>
        <CircularProgress
          size={33}
          style={{ padding: 6, color: statusTextError }}
          variant="determinate"
          value={errorCountdown}
        />
      </div>
    </div>
  ) : (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        borderRadius: 4,
        background: 'rgba(81, 40, 170, 0.12)',
        padding: '6px 16px',
        color: primaryBlue,
        marginTop: 16,
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <FilePresentOutlined />{' '}
        <div style={{ fontSize: 14, marginLeft: 8 }}>{fileWithMeta.file.name}</div>
      </div>

      <div style={{ display: 'flex', alignItems: 'center' }}>
        {fileWithMeta.status === 'uploading' ? (
          <CircularProgress size={33} style={{ padding: 6 }} />
        ) : (
          <Button
            variant="text"
            size="medium"
            onClick={() => {
              onDelete();
            }}
          >
            Delete <DeleteOutlineOutlined style={{ marginLeft: 8 }} />
          </Button>
        )}
      </div>
    </div>
  );
